<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '90vw', maxWidth: '1400px' }"
  [header]="'FIELD_IDENTIFICATION' | translate"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onClose()">
  <p-tabs
    [value]="activeTabValue"
    (valueChange)="onTabChange($event)">
    <p-tablist>
      <p-tab value="0">{{ "EDIT_AND_SAVE" | translate }}</p-tab>
      <p-tab value="1">{{ "REPLACE_FIELD_TAB" | translate }}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div
          class="field-details-modal"
          *ngIf="fieldData">
          <div class="flex flex-column gap-3">
            <div class="field-info-grid">
              <div class="field-info-row">
                <span class="label">{{ "AI ID" | translate }}:</span>
                <span class="value">{{ fieldData.cadastralNumber }}</span>
              </div>

              <div class="field-info-row">
                <span class="label">{{ "Area" | translate }}:</span>
                <span class="value">
                  {{ fieldData.areaHa || fieldData.area | number: "1.2-2" }}
                  {{ "HA" | translate }}
                </span>
              </div>

              <div class="field-info-row">
                <span class="label">{{ "Perimeter" | translate }}:</span>
                <span class="value">
                  {{ fieldData.perimeterM || fieldData.perimeter | number: "1.2-2" }}
                  {{ "m" | translate }}
                </span>
              </div>

              <div class="field-info-row">
                <span class="label">{{ "DETECTION_DATE" | translate }}:</span>
                <span class="value">{{ fieldData.createAt || fieldData.date | date }}</span>
              </div>
            </div>

            <div
              class="field-input-group mt-2"
              *ngIf="!isStopList">
              <label for="fieldName">{{ "NEW_FIELD_NAME" | translate }}</label>
              <input
                pInputText
                id="fieldName"
                [(ngModel)]="newFieldName"
                class="w-full"
                placeholder="{{ 'ENTER_FIELD_NAME' | translate }}" />
            </div>

            <div
              class="field-input-group mt-3"
              style="border-top: 1px solid #f0f0f0; padding-top: 12px">
              <div class="flex align-items-center gap-2">
                <p-checkbox
                  [(ngModel)]="isStopList"
                  [binary]="true"
                  inputId="stopListCheck"></p-checkbox>
                <label
                  for="stopListCheck"
                  class="m-0 font-bold"
                  style="cursor: pointer; color: #d32f2f">
                  {{ "ADD_TO_STOP_LIST" | translate }}
                </label>
              </div>
            </div>

            <div
              class="field-input-group mt-2"
              *ngIf="isStopList">
              <label for="stopListComment">{{ "COMMENT" | translate }}</label>
              <textarea
                pInputTextarea
                id="stopListComment"
                [(ngModel)]="stopListComment"
                rows="3"
                class="w-full"
                placeholder="{{ 'ENTER_COMMENT_OPTIONAL' | translate }}"></textarea>
            </div>

            <div class="modal-map-wrapper">
              <label
                class="mb-2 block font-bold"
                style="font-weight: 500; font-size: 14px; color: #374151">
                {{ "EDIT_BOUNDARY" | translate }}
              </label>

              <div class="map-container">
                <app-polygon-edit-map
                  #polygonMap
                  *ngIf="activeTabValue === '0' && visible"
                  [initialCoordinates]="editedPolygonPath"
                  (coordinateChange)="onPolygonEdited($event)"></app-polygon-edit-map>
              </div>

              <small style="color: #6b7280; margin-top: 4px; display: block">
                {{ "DRAG_POINTS_INFO" | translate }}
              </small>
            </div>
          </div>
        </div>
      </p-tabpanel>

      <p-tabpanel value="1">
        <div
          class="flex flex-column gap-3 mt-2"
          style="min-height: 500px">
          <div
            *ngIf="isLoadingIntersecting"
            class="flex justify-content-center align-items-center h-full">
            <i
              class="pi pi-spin pi-spinner"
              style="font-size: 2rem"></i>
            <span class="ml-2">{{ "SEARCHING_INTERSECTING" | translate }}</span>
          </div>

          <div
            *ngIf="!isLoadingIntersecting && intersectingFields.length > 0"
            class="split-maps-container">
            <div class="maps-area">
              <div class="map-column">
                <h4 class="mb-2 text-center text-overflow">
                  {{ "EDITED_POLYGON_AI" | translate }}
                </h4>
                <div class="map-frame">
                  <app-polygon-edit-map
                    #polygonMapSplit
                    *ngIf="activeTabValue === '1' && visible"
                    [initialCoordinates]="editedPolygonPath"
                    (coordinateChange)="onPolygonEdited($event)"></app-polygon-edit-map>
                </div>
              </div>

              <div class="map-column">
                <h4
                  class="mb-2 text-center text-overflow"
                  *ngIf="selectedTargetField">
                  {{ "EXISTING_FIELD_LABEL" | translate }}: {{ selectedTargetField.name }}
                </h4>
                <h4
                  class="mb-2 text-center"
                  *ngIf="!selectedTargetField">
                  {{ "SELECT_FIELD_LABEL" | translate }}
                </h4>

                <div class="map-frame bg-gray">
                  <app-polygon-edit-map
                    #polygonMapTarget
                    *ngIf="activeTabValue === '1' && selectedTargetField && visible"
                    [initialCoordinates]="targetFieldPolygonPath"
                    [isEditable]="false"></app-polygon-edit-map>
                  <div
                    *ngIf="!selectedTargetField"
                    class="placeholder-msg">
                    {{ "SELECT_FIELD_PREVIEW_INFO" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="list-area">
              <label class="block mb-2 font-bold text-sm">
                {{ "INTERSECTING_FIELDS" | translate }} ({{ intersectingFields.length }})
              </label>
              <div class="fields-list">
                <div
                  *ngFor="let field of intersectingFields"
                  class="field-item"
                  [class.selected]="selectedTargetField?.id === field.id"
                  (click)="selectTargetField(field)">
                  <div class="field-name">{{ field.name }}</div>
                  <div class="field-area">{{ field.area | number: "1.2-2" }} ha</div>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="!isLoadingIntersecting && intersectingFields.length === 0"
            class="text-center p-4">
            <p>{{ "NO_INTERSECTING_FIELDS" | translate }}</p>
          </div>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <ng-template pTemplate="footer">
    <button
      pButton
      label="{{ 'Delete' | translate }}"
      class="p-button-danger p-button-outlined"
      icon="pi pi-trash"
      [loading]="isDeleting"
      (click)="deleteAiField()"
      style="margin-right: 8px"></button>

    <button
      pButton
      label="{{ 'Center Map' | translate }}"
      class="p-button-secondary p-button-outlined"
      icon="pi pi-compass"
      (click)="centerMap()"
      style="margin-right: auto"></button>

    <button
      pButton
      label="{{ 'Cancel' | translate }}"
      class="p-button-text"
      (click)="onClose()"></button>

    <button
      *ngIf="activeTabValue === '0'"
      pButton
      [label]="(isStopList ? 'SAVE_TO_STOP_LIST' : 'SAVE_FIELD') | translate"
      [class.p-button-primary]="!isStopList"
      [class.p-button-danger]="isStopList"
      [icon]="isStopList ? 'pi pi-ban' : 'pi pi-check'"
      [loading]="isSaving"
      (click)="saveAiField()"></button>

    <button
      *ngIf="activeTabValue === '1'"
      pButton
      label="{{ 'REPLACE_FIELD_ACTION' | translate }}"
      class="p-button-warning"
      icon="pi pi-sync"
      [disabled]="!selectedTargetField"
      [loading]="isReplacing"
      (click)="replaceAiField()"></button>
  </ng-template>
</p-dialog>
